/* eslint-disable import/prefer-default-export */
import { CcsVariablePrefix, CcsExceptionMapVariablePrefix, PolicyLogsVariableType } from '../../../enums';
import { functionRegEx, variableIndexRegEx } from '../../../util';

export const UNDEFINED_POLICY_VARIABLE_DISPLAY = 'undefined';

export const lookupExceptionStr = (variable: string, exceptionsMap: { [key: string]: string }) => {
  let exceptionValue;

  if (
    variable.startsWith(`${CcsVariablePrefix.CONVERSATION}.`)
    && exceptionsMap[CcsVariablePrefix.CONVERSATION]
  ) {
    exceptionValue = exceptionsMap[CcsVariablePrefix.CONVERSATION];
  } else if (
    variable.startsWith(`${CcsVariablePrefix.CUSTOM}.`)
  ) {
    const [, customVarName] = variable.split('.');
    exceptionValue = exceptionsMap[`${CcsExceptionMapVariablePrefix.CUSTOM}-${customVarName}`];
  } else if (
    variable.startsWith(`${CcsVariablePrefix.SDE}.`)
    && exceptionsMap[CcsExceptionMapVariablePrefix.SDE]
  ) {
    exceptionValue = exceptionsMap[CcsVariablePrefix.SDE];
  } else {
    // check for Context exception
    const [namespace] = variable.split('.');
    Object.keys(exceptionsMap).forEach((key: string) => {
      const [, keyNamespace] = key.split(':');
      if (key.startsWith('Context-') && namespace === keyNamespace) {
        exceptionValue = exceptionsMap[key];
      }
    });
  }
  return exceptionValue;
};

export const replaceVariableIndexWithValue = (
  words: any, variables: any, transientVariables: any, valueMap: any,
) => {
  const [, varsIdx] = variableIndexRegEx.exec(words) as Array<string>;
  const [type, idx] = varsIdx.split(':');
  let variableStr = '';
  let val;
  if (type === PolicyLogsVariableType.VARIABLE) {
    variableStr = variables?.[+idx] || '';
    val = valueMap[variableStr];
  } else if (type === PolicyLogsVariableType.TRANSIENTVARIABLE) {
    const keys = Object.keys(transientVariables || {});
    const variableStrMatchRes = keys[+idx].match(functionRegEx);
    variableStr = variableStrMatchRes?.[1] || '';
    val = transientVariables?.[keys[+idx]];
  }
  return { variableStr, val };
};
